var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "visorPdfModal",
          attrs: { title: "Documento PDF", size: "xl", centered: "" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.visualizar(false)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("global.process.load.close")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticStyle: { width: "100%" } }, [
            _c("embed", {
              attrs: {
                src: this.contenidoBase64,
                type: "application/pdf",
                width: "100%",
                height: "600",
                frameborder: "1",
              },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }